export interface IAnnounceData {
  title?: string
  link?: string
  until?: number // expire-date
}

export const ANNOUNCEMENT_FILE_NAME = 'studio-announcement.json'
